import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import HighchartsVue from "highcharts-vue";
import Highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import Stock from "highcharts/modules/stock";


more(Highcharts);
Stock(Highcharts);
Vue.use(HighchartsVue);
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
